<section class="header-container" tourAnchor="{{stepKeys['Application']}}">
    <button class="app-menu-icon" (click)="toggleMenu()">
        <mat-icon>menu</mat-icon>
    </button>
    <div class="app-logo-name">
        <div class="app-logo">
            <img src="Lexus-Logo-transparent.png" alt="toyota logo" class="app-logo-img">
            <div class="app-name">
                <span class="cbl-name">CBL Reports Dashboard</span>
            </div>
        </div>
    </div>
    <div class="app-profile-container">
          <i class="fa-solid fa-question app-help-icon circle-icon" onKeyDown="" (click)="startTour()" tourAnchor="{{stepKeys['InfoIcon']}}" title="Application Assistant"></i>
        <div class="app-profile" onKeyDown="" (click)="isProfileOpen = !isProfileOpen" type="button" cdkOverlayOrigin #trigger="cdkOverlayOrigin" title="User Profile">
            <i class="fa-regular fa-circle-user app-profile-image" tourAnchor="{{stepKeys['Profile']}}"></i>
        </div>
        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isProfileOpen" 
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="isProfileOpen = false" >
            <div class="app-profile-userinfo">
                <div class="userinfo">
                    <span class="profile-element"><i class="fa-regular fa-circle-user app-prfl-image"></i></span>
                    <span class="profile-element">{{userInfo['userName']}}</span>
                    <span class="profile-element">{{userInfo['workdayId']}}</span>
                </div>
                <mat-divider></mat-divider>
                <div class="profile-actions">
                    <button class="logout-action pt-2" (click)="logout()">Logout</button>
                </div>
            </div>

        </ng-template>
    </div>
</section>